import './styles/App.css';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import SmoothScroll from './components/common/SmoothScroll';
import WhatsAppButton from './components/common/WhatsAppButton';
import Hero from './components/sections/Hero';
import Clinica from './components/sections/Clinica';
import Especialidades from './components/sections/Especialidades';
import Protocolos from './components/sections/Protocolos';
import Profissionais from './components/sections/Profissionais';
import Noticias from './components/sections/Noticias';
import Artigo from './components/sections/Artigo';
import Missao from './components/sections/Missao';
import Contato from './components/sections/Contato';

function App() {
  return (
    <div className="App">
      <SmoothScroll />
      <Navbar />
      <Hero />
      <Clinica />
      <Especialidades />
      <Protocolos />
      <Profissionais />
      <Missao />
      <Noticias />
      <Artigo />
      <Contato />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
